import { EmoticonAngryOutlineIcon } from './EmoticonAngryOutlineIcon';

/**
 * author: Michael Irigoyen
 * id EEE3E9C1-D1B5-4D57-AD8B-7F6AD4852EE6
 * name emoticon-angry-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-angry-outline.svg
 * tags
 * - Emoji 
 */
export const SmileyAngryOutlineIcon = EmoticonAngryOutlineIcon;
export default SmileyAngryOutlineIcon